module.exports = __webpack_public_path__ + "nucleo-icons.48ac036da7c792326626.ttf";


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/src/assets/fonts/nucleo-icons.ttf
// module id = ../../../../../src/assets/fonts/nucleo-icons.ttf
// module chunks = 3